import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren } from "react";
import { useRegionConfig } from "modules/i18n/hooks/useRegionConfig";
import { Link } from "common/components/Footer/Link";
import { SocialMediaLink } from "common/components/Footer/SocialMediaLink";
import { ConsentPreferencesLink } from "common/components/Footer/ConsentPreferencesLink";
import { FooterLink } from "modules/i18n/utils/loadRegionConfiguration";
import { useTranslations } from "modules/i18n/hooks/useTranslations";
interface FooterProps {
  year: number;
}
export const Footer = t0 => {
  "use memo";

  const $ = _c(35);
  const {
    year
  } = t0;
  const t = useTranslations("layout.footer");
  const {
    footer: t1
  } = useRegionConfig();
  const {
    first_column: firstColumn,
    second_column: secondColumn,
    social_media: socialMedia,
    copyright_first_column: copyrightFirstColumn,
    copyright_notice_html: copyrightNoticeHtml
  } = t1;
  const mapFooterLinks = _temp2;
  let t2;
  if ($[0] !== firstColumn) {
    t2 = mapFooterLinks(firstColumn);
    $[0] = firstColumn;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const firstColumnLinks = t2;
  let t3;
  if ($[2] !== secondColumn) {
    t3 = mapFooterLinks(secondColumn);
    $[2] = secondColumn;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const secondColumnLinks = t3;
  let t4;
  if ($[4] !== copyrightFirstColumn) {
    t4 = mapFooterLinks(copyrightFirstColumn);
    $[4] = copyrightFirstColumn;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const copyrightColumnLinks = t4;
  let t5;
  if ($[6] !== socialMedia) {
    t5 = socialMedia.map(_temp3);
    $[6] = socialMedia;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const socialMediaLinks = t5;
  let t6;
  if ($[8] !== t) {
    t6 = t("footer_nav_label");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== firstColumnLinks) {
    t7 = <div className="order-2 col-span-full flex flex-col sm:col-span-4 md:order-1 xl:col-span-3">{firstColumnLinks}</div>;
    $[10] = firstColumnLinks;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== secondColumnLinks) {
    t8 = <div className="order-1 col-span-full flex flex-col sm:col-span-4 md:order-2 xl:col-span-3">{secondColumnLinks}</div>;
    $[12] = secondColumnLinks;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t) {
    t9 = t("social_footer");
    $[14] = t;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== socialMediaLinks || $[17] !== t9) {
    t10 = <div aria-label={t9} className="order-last col-span-full flex flex-row flex-wrap place-content-start justify-center gap-3 justify-self-end py-5 sm:col-span-4 sm:justify-start lg:py-0 xl:col-span-6">{socialMediaLinks}</div>;
    $[16] = socialMediaLinks;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t7 || $[21] !== t8) {
    t11 = <div className="tc-container container mx-auto grid grid-cols-12 py-6">{t7}{t8}{t10}</div>;
    $[19] = t10;
    $[20] = t7;
    $[21] = t8;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== copyrightNoticeHtml || $[24] !== year) {
    t12 = copyrightNoticeHtml.replace("%{year}", year.toString());
    $[23] = copyrightNoticeHtml;
    $[24] = year;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12) {
    t13 = <div className="mx-auto lg:mr-0 lg:ml-auto"><span dangerouslySetInnerHTML={{
        __html: t12
      }} /></div>;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== copyrightColumnLinks || $[29] !== t13) {
    t14 = <div className="bg-black"><section className="tc-container text-2xs container mx-auto flex flex-col gap-4 py-4 md:flex-row 2xl:text-xs">{copyrightColumnLinks}{t13}</section></div>;
    $[28] = copyrightColumnLinks;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t11 || $[32] !== t14 || $[33] !== t6) {
    t15 = <footer className="mt-auto bg-gray-900 text-center text-white md:text-left lg:text-left" data-testid="footer"><nav aria-label={t6}>{t11}{t14}</nav></footer>;
    $[31] = t11;
    $[32] = t14;
    $[33] = t6;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  return t15;
};
function _temp(t0) {
  const {
    url,
    title,
    label,
    didomi_preferences
  } = t0;
  if (didomi_preferences) {
    return <ConsentPreferencesLink key="didomi-preferences" title={title}>{label}</ConsentPreferencesLink>;
  }
  return <Link key={url} href={url} title={title}>{label}</Link>;
}
function _temp2(links) {
  return links.map(_temp);
}
function _temp3(t0) {
  const {
    url: url_0,
    title: title_0,
    icon
  } = t0;
  return <SocialMediaLink key={url_0} title={title_0} href={url_0} icon={icon} />;
}